import { render, staticRenderFns } from "./companyMenu.vue?vue&type=template&id=d3180a8a"
import script from "./companyMenu.vue?vue&type=script&lang=js"
export * from "./companyMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports